import { render } from "./external-home.vue?vue&type=template&id=6cf79b4b&scoped=true"
import script from "./external-home.vue?vue&type=script&lang=js"
export * from "./external-home.vue?vue&type=script&lang=js"

import "./external-home.vue?vue&type=style&index=0&id=6cf79b4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf79b4b"]])

export default __exports__